import { useContext } from 'react';
import { PageTitleContext } from '../context/page-title';

export const usePageTitle = () => {
  const { title } = useContext(PageTitleContext);
  return title;
};

export default usePageTitle;
